import { LoadingRings } from "@/components/ui/loading-rings";

/**
 * Full-screen loading state — the Figma `Loading` frame (node 1809:9732).
 *
 * The drawing itself lives in `LoadingRings`, which is also usable inline for
 * section-level waits. This component is only the full-screen framing around it:
 * page background, the caption, and the vertical anchor.
 *
 * The wrapper is an `<output>` rather than a `div` with `role="status"`: both
 * announce politely, but `output` carries the role implicitly and is what
 * `jsx-a11y/prefer-tag-over-role` asks for. `LoadingRings` is decorative, so the
 * caption is the only thing assistive tech reads out.
 *
 * `pb-7` nudges the centred column up by 14px. Figma anchors the circles' centre
 * at `50% - 46px` rather than the frame's midpoint, and half the bottom padding
 * is what reproduces that offset without absolute positioning.
 */
export function PageLoader() {
  return (
    <output className="flex h-dvh w-full flex-col items-center justify-center bg-[#f6f6f9] pb-7">
      <LoadingRings size="lg" />
      <p className="mt-[41px] text-center text-[16px] leading-[24px] font-semibold text-[#4d577c]">
        Loading...
      </p>
    </output>
  );
}
